import { type DevicePlatform } from './types';

// Совпадают с PlatformClass из @direct-frontend/platform-code
export const PLATFORM_COMMON_CLASS = 'platform-common';
export const PLATFORM_MOBILE_CLASS = 'platform-mobile';
export const PLATFORM_DESKTOP_CLASS = 'platform-desktop';

export const getPlatformWrapperClassName = (platform: DevicePlatform): string =>
    platform === 'mobile'
        ? `${PLATFORM_COMMON_CLASS} ${PLATFORM_MOBILE_CLASS}`
        : `${PLATFORM_COMMON_CLASS} ${PLATFORM_DESKTOP_CLASS}`;

export const syncPlatformDocumentClass = (platform: DevicePlatform): void => {
    if (typeof document === 'undefined') {
        return;
    }

    const { classList } = document.documentElement;

    classList.add(PLATFORM_COMMON_CLASS);
    classList.remove(PLATFORM_MOBILE_CLASS, PLATFORM_DESKTOP_CLASS);
    classList.add(platform === 'mobile' ? PLATFORM_MOBILE_CLASS : PLATFORM_DESKTOP_CLASS);
};
